import _ from 'lodash';
import moment from 'moment';
import BillyApi from '@/api/BillyApi';

const state = {
  purchasedVouchersCountByVendorAndMonth: {},
  vouchersData: null,
};

const getters = {
  customerEverPurchasedVoucher: state => vendor =>
    _.keys(state.purchasedVouchersCountByVendorAndMonth[vendor] || {}).length > 0,
  currentMonthCountByVendor: state => vendor => {
    const currentMonth = moment().format('YYYY-MM');
    return (state.purchasedVouchersCountByVendorAndMonth[vendor] && state.purchasedVouchersCountByVendorAndMonth[vendor][currentMonth]) || 0;
  },
  remainingDaysInMonth: () => {
    const today = moment().startOf('day');
    const endOfMonth = moment().endOf('month').startOf('day');
    return endOfMonth.diff(today, 'days') + 1;
  },
};

const actions = {
  async init({ commit, state }) {
    const purchasedVouchersCountByVendorAndMonth = await BillyApi.getVouchersStats();
    commit('setPurchasedVouchersCountByVendorAndMonth', purchasedVouchersCountByVendorAndMonth);
  },
};

const mutations = {
  setPurchasedVouchersCountByVendorAndMonth(state, purchasedVouchersCountByVendorAndMonth) {
    state.purchasedVouchersCountByVendorAndMonth = purchasedVouchersCountByVendorAndMonth;
  },
  setVouchersData(state, data) {
    state.vouchersData = data;
  },
  clearVouchersData(state) {
    state.vouchersData = null;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
